import type { WhiteListItem } from '../declare'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react'
import { Form, Collapse, Row, Col } from 'antd'
import { EditPropsContext, EditContext, LoadableControl, ExpandedRemark } from 'src/components'
import { getModalColumnsSpan } from '../helper'
import { $consts } from 'src/plugins'

const EditPageColumns = () => {
  const editProps = useContext(EditPropsContext)
  const edit = useContext(EditContext)

  const formParams = useMemo(() => {
    return editProps?.formData?.formDisabled !== undefined ? { __READONLY__: editProps.formData.formDisabled } : {}
  }, [editProps?.formData?.formDisabled])

  const columnsNum = useMemo(() => {
    return edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.COL_NUM
  }, [edit.editConfig.Nav_PageEdit?.Nav_PageEdit?.COL_NUM])

  // 主体区域
  const pagerColumns = useMemo(() => {
    return edit.validNavColumns.filter((col: any) => !col.PAGE_EDIT_PANEL_ID)
  }, [edit.validNavColumns])

  // 折叠区域
  const collapseColumns = useMemo(() => {
    const editPanels = edit.editConfig.Nav_PageEdit?.Nav_EditPanels || []
    const panels: any = editPanels.map(({ ID: id, LABEL: label }: any) => ({ id, label }))
    const targetColumns = edit.validNavColumns.filter((col: any) => col.PAGE_EDIT_PANEL_ID)
    targetColumns.forEach((col: any) => {
      const find = panels.find((pan: any) => pan.id === col.PAGE_EDIT_PANEL_ID)
      !find.items && (find.items = [])
      find.items.push(col)
    })
    return panels.filter((pan: any) => !!pan.items)
  }, [edit.validNavColumns])

  const collapseDefaultKey = useMemo(() => {
    return collapseColumns.map((col: any, index: number) => `${col.id}_${index}`)
  }, [collapseColumns])

  const collapseItems = useMemo(() => {
    return collapseColumns.map((col: any, index: number) => {
      return {
        key: `${col.id}_${index}`,
        label: col.label,
        children: (
          <Form layout='vertical'>
            <Row gutter={24}>
              {
                col.items.map((item: any, index: number) => {
                  return (
                    <Col key={`${item.ID}_${index}`} span={getModalColumnsSpan(columnsNum, item.WIDTH)}>
                      <LoadableControl
                        pageType={$consts['TABLE/FORM_TYPE_EDIT_PAGE']}
                        locateControl={$consts['TABLE/CONTROL_LOCATE_PAGER']}
                        config={Object.assign({}, item, formParams)}
                      />
                    </Col>
                  )
                })
              }
            </Row>
          </Form>
        )
      }
    })
  }, [formParams, columnsNum, collapseColumns])

  return (
    <React.Fragment>
      <ExpandedRemark
        expanded={edit.editConfig?.Nav_Form?.REMARK_EXPAND}
        remark={edit.editConfig?.Nav_Form?.REMARK}
      />
      {
        pagerColumns.length
          ? (
            <Form layout='vertical'>
              <Row gutter={24}>
                {
                  pagerColumns.map((item: any, index: number) => {
                    const hidden = edit.verifyWhiteList.find((list: WhiteListItem) => list.field === item.FIELD_NAME)?.hidden === true
                    return (
                      <Col key={`${item.ID}_${index}`} span={hidden ? 0 : getModalColumnsSpan(columnsNum, item.WIDTH)}>
                        <LoadableControl
                          pageType={$consts['TABLE/FORM_TYPE_EDIT_PAGE']}
                          locateControl={$consts['TABLE/CONTROL_LOCATE_PAGER']}
                          config={Object.assign({}, item, formParams)}
                        />
                      </Col>
                    )
                  })
                }
              </Row>
            </Form>
          )
          : null
      }
      {collapseColumns.length ? <Collapse defaultActiveKey={collapseDefaultKey} items={collapseItems} /> : null}
    </React.Fragment>
  )
}

export default observer(EditPageColumns)